/* eslint-disable complexity */
import {
    GET_MERCHANT_INFO_SUCCESS,
    GET_MERCHANT_INFO_ERROR,
    FETCH_PG_CONFIG_EDIT_SUCCESS,
    FETCH_PG_CONFIG_EDIT_ERROR,
    FETCH_ROUTER_DETAILS_SUCCESS,
    FETCH_ROUTER_DETAILS_ERROR,
    FETCH_SURCHARGE_DETAILS_SUCCESS,
    FETCH_SURCHARGE_DETAILS_ERROR,
    UPDATE_MERCHANT_DATA_REQUEST,
    UPDATE_MERCHANT_DATA_SUCCESS,
    UPDATE_MERCHANT_DATA_ERROR,
    UPDATE_PG_CONFIG_DATA_REQUEST,
    UPDATE_PG_CONFIG_DATA_SUCCESS,
    UPDATE_PG_CONFIG_DATA_ERROR,
    UPDATE_ROUTING_DATA_REQUEST,
    UPDATE_ROUTING_DATA_SUCCESS,
    UPDATE_ROUTING_DATA_ERROR,
    UPDATE_SURCHARGE_DATA_REQUEST,
    UPDATE_SURCHARGE_DATA_SUCCESS,
    UPDATE_SURCHARGE_DATA_ERROR,
    UPDATE_SECTION_DETAILS_REQUEST,
    UPDATE_SECTION_DETAILS_SUCCESS,
    UPDATE_SECTION_DETAILS_ERROR,
    RESET_UPDATE_DATA_SUCCESS_KEY,
    GET_MERCHANT_SECTION_INFO_SUCCESS,
    GET_MERCHANT_SECTION_INFO_ERROR,
    SET_SELECTED_ENTITY_SUCCESS,
    SET_SELECTED_ENTITY_ERROR,
    UPDATE_SETTLEMENT_DATA_REQUEST,
    UPDATE_SETTLEMENT_DATA_SUCCESS,
    UPDATE_SETTLEMENT_DATA_ERROR,
    FETCH_BASIC_FORM_DATA_SUCCESS,
    ADD_MERCHANT_STEP_UPDATE_MAKER_REQUEST,
    ADD_MERCHANT_STEP_UPDATE_MAKER_SUCCESS,
    ADD_MERCHANT_STEP_UPDATE_MAKER_ERROR,
} from './editMerchant.constants';
import { first } from 'lodash';

export const initialState = {
    sections: [],
    error: {},
    entityValues: {},
    updateData: {
        isUpdated: false,
        error: {},
    },
    basicFormData: {},
    loading: false,
};

const setSingleSection = (sections, payload) => {
    const singleSection = first(payload);
    const filteredSection = sections.filter(
        item => item.type !== singleSection.type
    );
    return [...filteredSection, ...payload];
};

export const editMerchantReducer = (state = initialState, action) => {
    const sections = state.sections.map(item => {

    })

    switch (action.type) {
        case GET_MERCHANT_INFO_SUCCESS: {
            return { ...state, sections: [...action.payload] };
        }
        case GET_MERCHANT_INFO_ERROR:
            return { ...state, ...action.payload };
        case FETCH_PG_CONFIG_EDIT_SUCCESS: {
            const sectionData = setSingleSection(
                state.sections,
                action.payload
            );
            return { ...state, sections: sectionData };
        }
        case FETCH_PG_CONFIG_EDIT_ERROR:
            return { ...state, ...action.payload };
        case FETCH_ROUTER_DETAILS_SUCCESS: {
            const sectionData = setSingleSection(
                state.sections,
                action.payload
            );
            return { ...state, sections: sectionData };
        }
        case FETCH_ROUTER_DETAILS_ERROR:
            return { ...state, ...action.payload };
        case FETCH_SURCHARGE_DETAILS_SUCCESS: {
            const sectionData = setSingleSection(
                state.sections,
                action.payload
            );
            return { ...state, sections: sectionData };
        }
        case GET_MERCHANT_SECTION_INFO_SUCCESS:
            const sectionData = setSingleSection(
                state.sections,
                action.payload
            );
            return { ...state, sections: sectionData };

        case GET_MERCHANT_SECTION_INFO_ERROR:
            return { ...state, ...action.payload };

        case FETCH_SURCHARGE_DETAILS_ERROR:
            return { ...state, ...action.payload };
        case UPDATE_PG_CONFIG_DATA_REQUEST:
        case UPDATE_MERCHANT_DATA_REQUEST:
        case UPDATE_ROUTING_DATA_REQUEST:
        case UPDATE_SETTLEMENT_DATA_REQUEST:
        case UPDATE_SURCHARGE_DATA_REQUEST:
        case UPDATE_SECTION_DETAILS_REQUEST: {
            const updateData = { ...state.updateData, ...{ isUpdated: false } };
            return { ...state, updateData: { ...updateData } };
        }
        case UPDATE_PG_CONFIG_DATA_SUCCESS:
        case UPDATE_MERCHANT_DATA_SUCCESS:
        case UPDATE_SECTION_DETAILS_SUCCESS:
        case UPDATE_ROUTING_DATA_SUCCESS:
        case UPDATE_SETTLEMENT_DATA_SUCCESS:
        case UPDATE_SURCHARGE_DATA_SUCCESS: {
            const updateData = {
                ...state.updateData,
                isUpdated: true,
                sectionType: action.sectionType,
            };
            return {
                ...state,
                updateData: { ...updateData },
            };
        }

        case UPDATE_PG_CONFIG_DATA_ERROR:
        case UPDATE_MERCHANT_DATA_ERROR:
        case UPDATE_ROUTING_DATA_ERROR:
        case UPDATE_SURCHARGE_DATA_ERROR:
        case UPDATE_SETTLEMENT_DATA_ERROR:
        case UPDATE_SECTION_DETAILS_ERROR: {
            const updateData = {
                ...state.updateData,
                ...action.payload,
                isUpdated: false,
            };
            return { ...state, updateData: { ...updateData } };
        }
        case RESET_UPDATE_DATA_SUCCESS_KEY: {
            return { ...state, updateData: { isUpdated: false, error: {} } };
        }
        case SET_SELECTED_ENTITY_SUCCESS: {
            return { ...state, entityValues: { ...action.payload } };
        }
        case SET_SELECTED_ENTITY_ERROR:
            return { ...state, ...action.payload };
        case FETCH_BASIC_FORM_DATA_SUCCESS:
            return { ...state, basicFormData: action.payload.basicSectionData};
        case ADD_MERCHANT_STEP_UPDATE_MAKER_REQUEST: {
            const updateData = { ...state.updateData, ...{ isUpdated: false } };
            return { ...state, updateData: { ...updateData } };
        }
        case ADD_MERCHANT_STEP_UPDATE_MAKER_SUCCESS: {
            const updateData = {
                ...state.updateData,
                isUpdated: true,
                sectionType: action.sectionType,
            };
            return {
                ...state,
                updateData: { ...updateData },
            };
        }
        case ADD_MERCHANT_STEP_UPDATE_MAKER_ERROR: {
            const updateData = {
                ...state.updateData,
                ...action.payload,
                isUpdated: false,
            };
            return { ...state, updateData: { ...updateData } };
        }
        default:
            return state;
    }
};
